import React from 'react';
import PropTypes from 'prop-types';
import { StarIcon } from '../../../../components/ui/icons';
import i18n from '../../../../shared/util/i18n';
import styles from './RatingRow.module.css';

export default function RatingRow({ value = 0 }) {
  const full = Math.floor(value);

  return (
    <div className={styles.root}>
      <span className={styles.label}>{i18n.t('AVALIATIONS')}:</span>
      <div className={styles.stars}>
        {[0, 1, 2, 3, 4].map(i => (
          <StarIcon
            key={i}
            value={1}
            className={i < full ? undefined : styles.starEmpty}
          />
        ))}
      </div>
    </div>
  );
}

RatingRow.propTypes = {
  value: PropTypes.number
};
